export enum ToastrMessageType {
    Error = 1,
    Info = 2,
    Success = 3,
    Warning = 4
  }
